import theme from '@nextretreat/ui-components/dist/Theme'
import { BORDER_WIDTH, BOXSHADOWS, COLORS } from 'Theme'

export const defaultStyle = `
  cursor: pointer;

  border: ${BORDER_WIDTH} solid ${COLORS.SILK_SOX};
  box-shadow: ${BOXSHADOWS.DARK};
  background-color: ${theme.COLORS.WHITE};
`

export const hoverStyle = `
  border-color: ${theme.COLORS.BRAND_DEFAULT};
`

export const activeStyle = `
  border-color: ${theme.COLORS.BRAND_DEFAULT} !important;
  box-shadow: ${BOXSHADOWS.INNER} !important;
  background-color: ${COLORS.IRRADIANT_IRIS} !important;
`

export const disabledStyle = `
  cursor: default;

  color: ${COLORS.BLUEBERRY_SODA};
  box-shadow: none !important;
  background-color: ${COLORS.LYNX_WHITE} !important;

  & {
    border-color: ${COLORS.IRRADIANT_IRIS} !important;
  }

  @media (hover: hover) {
    &:hover {
      border-color: ${COLORS.IRRADIANT_IRIS} !important;
    }
  }
`
